export enum Owner {
    USER = 1,
    NEWS,
    MANAGEMENT,
    EVENTS = 4,
    PARTNERS = 5,
    DEVELOPMENT_HISTORY = 6,
    COURSES = 7,
}
